import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'

import {
  updateTablesAction,
  clearTables,
} from 'containers/Entity/actions'

import {
  get,
  post
} from 'helpers/RequestUtil'

import {
  UPDATE_ACTIVE_DIALOG
} from 'containers/Admin/User/User/constants'

import {
  CHANGE_SELECTED_ROLE,
  CHANGE_SELECTED_USER,
  POST_USER,
} from './constants'

import {
  userSelector,
  roleStateSelector,
  userStateSelector,
} from './selectors'

import {
  resetSelectedRole,
  resetSelectedUser,
  updateSelectedRole,
  updateSelectedUser,
  postUserStart,
  postUserSuccess,
  postUserError,
  startPostUserAsync
} from './actions'

import {
  fetchUsers,
} from 'containers/Admin/User/UserSelection/actions'

function* postUser(username, role) {
  try {
    yield put(startPostUserAsync())
    yield put(postUserStart())
    const data = yield call(
      post,
      'roles',
      { role, username },
      '/api/fulcrum/users/roles'
    )
    yield put(postUserSuccess())
    return data
  } catch(error) {
    yield put(postUserError(error))
  }
}

function* handlePostUser() {
  const username = yield select(userStateSelector)
  const role = yield select(roleStateSelector)
  yield call(postUser, username, role)
  yield put(fetchUsers())
}

function* handleChangeSelectedUser(action) {
  const { user: { username } } = action
  yield put(updateSelectedUser(username))
}

function* handleChangeSelectedRole(action) {
  const { role } = action
  yield put(updateSelectedRole(role))
}

function* handleUpdateActiveDialog(action) {
  if (!action.active) {
    yield put(resetSelectedRole())
    yield put(resetSelectedUser())
  }
}

function* watchUpdateActiveDialog() {
  yield takeLatest(UPDATE_ACTIVE_DIALOG, handleUpdateActiveDialog)
}

function* watchChangeSelectedUser() {
  yield takeLatest(CHANGE_SELECTED_USER, handleChangeSelectedUser)
}

function* watchChangeSelectedRole() {
  yield takeLatest(CHANGE_SELECTED_ROLE, handleChangeSelectedRole)
}

function* watchPostUser() {
  yield takeEvery(POST_USER, handlePostUser)
}

function* loadSagas() {
  yield all([
    fork(watchPostUser),
    fork(watchChangeSelectedUser),
    fork(watchChangeSelectedRole),
    fork(watchUpdateActiveDialog),
  ])
}

export default loadSagas
